import React, {FormEvent, useState} from 'react'
import {Uploader} from '../image_uploader'
import {sendErrorDocumentReport} from '../../rest'

interface ErrorDocFormProps {
    documentId: string
    documentVersion: number;
    successfulSubmitCallback?: () => unknown
}

export const ErrorDocForm: React.FC<ErrorDocFormProps> = ({
                                                              documentId,
                                                              documentVersion,
                                                              successfulSubmitCallback
                                                          }) => {

    const [uploadImage, setUploadImage] = useState<File>()
    const [reportMsg, setReportMsg] = useState<string>('')
    const [reportMsgError, setReportMessageError] = useState<string | undefined>()
    const [uploadImageMsgError, setUploadImageMsgError] = useState<string | undefined>()

    const isValid = (): boolean => {
        let result = true
        setReportMessageError(undefined)

        if (reportMsg.length === 0) {
            setReportMessageError('Сообщение не может быть пустым')
            result = false
        } else if (reportMsg.length < 5) {
            setReportMessageError('Сообщение не может быть меньше 5 символов')
            result = false
        }

        if (!uploadImage) {
            setUploadImageMsgError('Загрузите фотографию')
            return false
        }

        return result
    }

    const submit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (isValid() && uploadImage) {
            sendErrorDocumentReport({
                documentId,
                reportMsg,
                image: uploadImage
            }).then(() => {
                successfulSubmitCallback?.()
            })
        }
    }

    return (
            <form onSubmit={submit}>
                <div className="coll-span-full">
                    <div className="">
                    <textarea id="error-msg"
                              name="error-msg"
                              rows={3}
                              placeholder="Опишите ошибку... "
                              className="block w-full border border-1 p-1.5 text-gray-700 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                              onChange={(event => setReportMsg(event.target.value))}
                    />
                        <p className={`-mb-2 text-sm text-red-600 ${reportMsgError ? 'opacity-100' : 'opacity-0'}`}>
                            {reportMsgError ?? ' - '}
                        </p>
                    </div>
                </div>

                <div className="col-span-full mt-5">
                    <Uploader
                            file={uploadImage}
                            setFile={setUploadImage}
                            maxSizeBytes={10 * 1024 * 1024}
                            accept={['image/png', 'image/jpg', 'image/jpeg']}
                            titleText={
                                <>
                                    <span>Загрузите фотографию</span>
                                    <p className="text-xs leading-5 text-gray-600">
                                        PNG, JPG до 10MB
                                    </p>
                                </>
                            }/>
                    <p className={`-mb-2 text-sm text-red-600 ${uploadImageMsgError ? 'opacity-100' : 'opacity-0'}`}>
                        {uploadImageMsgError ?? ' - '}
                    </p>
                </div>
                <div className="mt-5 sm:flex sm:flex-row-reverse sm:px-0">
                    <button
                            type="submit"
                            className="inline-flex w-full justify-center bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-400 sm:ml-3 sm:w-auto"
                    >
                        Отправить
                    </button>
                </div>
            </form>
    )

}
